import React from 'react'
import OrderDetails from '../features/order/Components/OrderDetails'

const OrderDetailsPages = () => {
  return (
    <OrderDetails />
  )
}

export default OrderDetailsPages